import type { Config, Mixpanel } from 'mixpanel-browser'

export const MIXPANEL_CONFIG: Partial<Config> = {
  api_host: 'https://api-eu.mixpanel.com',
  // Loga no console cada evento enviado e a resposta, só em desenvolvimento.
  debug: import.meta.env.DEV,
  autocapture: false,
  track_pageview: false,
  record_sessions_percent: 0,
  ip: false,
  // Sem cookie nem localStorage do SDK. O envio em lote é desligado porque a
  // fila dele grava no localStorage mesmo com `disable_persistence`.
  disable_persistence: true,
  batch_requests: false,
  save_referrer: false,
  store_google: false,
  // O SDK anexa a URL atual a todo evento; no detalhe ela contém o diagnosticId.
  property_blacklist: [
    '$current_url',
    '$referrer',
    '$referring_domain',
    '$initial_referrer',
    '$initial_referring_domain'
  ]
}

/** Carrega o SDK sob demanda, para que ele só entre no navegador com token configurado. */
export const loadMixpanel = async (token: string): Promise<Mixpanel> => {
  const { default: mixpanel } = await import('mixpanel-browser')
  mixpanel.init(token, MIXPANEL_CONFIG)
  return mixpanel
}
